import { render, staticRenderFns } from "./ListedApartments.vue?vue&type=template&id=8188dfd4&"
import script from "./ListedApartments.vue?vue&type=script&lang=js&"
export * from "./ListedApartments.vue?vue&type=script&lang=js&"
import style0 from "./ListedApartments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports